import configUrl from './configUrl';

export const mockSuccessData = {
  code: 'SUCCESS',
  message: 'reset GA4 connection successfully',
  data: {
    advertiserId: 123,
    ga4_property_id: null
  }
}

export const mockFailData = {
  code: 'FAILED',
  message: "reset GA4 connection failure",
}

export const getResetConnectionEndpoint = (advertiserId) => `${configUrl.baseUrl}${configUrl.advertiser}/${advertiserId}/google_analytics_4/reset_connection`;